import styled, { css } from 'styled-components';
import { media } from '../../ui';
export const Badge = styled.div.withConfig({
  displayName: "Style__Badge",
  componentId: "sc-148ncxg-0"
})(["position:absolute;bottom:-121px;left:-62px;height:100%;", ""], media.md`
    top: -23px;
    left: 31%;
    bottom: 0;
  `);
export const BadgeText = styled.div.withConfig({
  displayName: "Style__BadgeText",
  componentId: "sc-148ncxg-1"
})(["padding:2px 6px;color:", ";background-color:#FF8400;border-top-left-radius:4px;border-top-right-radius:4px;transform:rotate(-90deg);", ""], ({
  theme: {
    color
  }
}) => color.white, media.md`
    transform: none;
  `);
export const SeatMapWrapper = styled.div.withConfig({
  displayName: "Style__SeatMapWrapper",
  componentId: "sc-148ncxg-2"
})(["", ""], ({
  isTwoFloor
}) => isTwoFloor && css(["display:table;margin:0 auto;.ticket__place-row{justify-content:flex-end;}.ticket__place-picker{> .flex.justify-center{display:block;}&:first-child{.ticket__place-picker--wrap{padding-right:36px;", "}}}"], media.md`
            padding-right: 10px;
            padding-top: 36px;
          `));